import * as React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import Image from 'next/image';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { motion } from 'framer-motion';
import CloseIcon from '@mui/icons-material/Close';


const pages = [
    { name: 'Home', href: '/' },
    { name: 'Why Scriptu', href: '#whyus' },
    { name: 'Features', href: '#features' },
    { name: 'Pricing', href: '/pricing' },
    { name: 'Lifetime Deal', href: '/ltd?source=site' },
];

export default function Header() {
    const router = useRouter();
    const [anchorElNav, setAnchorElNav] = React.useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    return (
        <div id="home">
            <AppBar position="fixed" sx={{
                background: 'rgba(0, 1, 57, 0.74)',
                backdropFilter: 'blur(10px)',
                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
            }}>
                <Container maxWidth="lg" >
                    <Toolbar disableGutters>
                        <Box sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} >
                            <Link href="/">
                                <Image src="/logo-main.png" alt="Scriptu.io" width={600} height={166} style={{ width: '168px', height: '40px' }} priority />
                            </Link>
                        </Box>


                        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                color="inherit"
                            >
                                <MenuIcon sx={{ color: 'white' }} />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                sx={{
                                    display: { xs: 'block', md: 'none' },
                                    '& .MuiMenu-paper': {
                                        background: 'rgba(0, 1, 57, 0.74)',
                                        backdropFilter: 'blur(10px)',
                                        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                                        width: '100%',
                                        maxWidth: '100%',
                                        maxHeight: '100%',
                                        left: '0 !important',

                                    },
                                }}
                            >
                                {pages.map((page, index) => (
                                    <MenuItem key={index} onClick={handleCloseNavMenu}>
                                        <Button
                                            key={`${page.name}-${index}`} // Ensuring a unique key for each Button
                                            onClick={(e) => {
                                                // Check if the href is a hash (internal link)
                                                if (page.href.startsWith('#')) {
                                                    const section = document.querySelector(page.href);
                                                    if (section) {
                                                        e.preventDefault(); // Prevent the default anchor link behavior
                                                        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                                    } else {
                                                        // If the section doesn't exist on the current page,
                                                        // prevent the default behavior and navigate programmatically
                                                        e.preventDefault();
                                                        // Navigate to the home page (or index page) and append the hash
                                                        router.push(`/${page.href}`);
                                                    }
                                                }
                                                // External paths are handled normally, as before
                                            }}
                                            href={page.href} // This is important for SEO and accessibility reasons
                                            sx={{
                                                my: 1, mx: 1.5, fontWeight: 600, color: 'white', display: 'block',
                                                '&:hover': {
                                                    color: '#de80a0',
                                                }
                                            }}
                                        >
                                            {page.name}
                                        </Button>
                                    </MenuItem>
                                ))}

                            </Menu>
                        </Box>


                        <Typography
                            variant="h5"
                            noWrap
                            component="a"
                            href="#app-bar-with-responsive-menu"
                            sx={{
                                mr: 2,
                                display: { xs: 'flex', md: 'none' },
                                flexGrow: 1,
                                fontFamily: 'monospace',
                                fontWeight: 700,
                                letterSpacing: '.3rem',
                                color: 'inherit',
                                textDecoration: 'none',
                            }}
                        >
                            <Image src="/logo-main.png" alt="Scriptu" width={600} height={166} style={{ width: '116px', height: '30px' }} priority />
                        </Typography>
                        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'center' }}>
                            {pages.map((page) => (
                                <Button
                                    key={page.name}
                                    onClick={(e) => {
                                        // Check if the href is a hash (internal link)
                                        if (page.href.startsWith('#')) {
                                            const section = document.querySelector(page.href);
                                            if (section) {
                                                e.preventDefault(); // Prevent the default anchor link behavior
                                                section.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                            } else {
                                                // If the section doesn't exist on the current page,
                                                // prevent the default behavior and navigate programmatically
                                                e.preventDefault();
                                                // Navigate to the home page (or index page) and append the hash
                                                router.push(`/${page.href}`);
                                            }
                                        }
                                        // External paths are handled normally, as before
                                    }}
                                    href={page.href} // This is important for SEO and accessibility reasons
                                    sx={{
                                        my: 1, mx: 1.5, fontWeight: 600, color: 'white', display: 'block',
                                        '&:hover': {
                                            color: '#de80a0',
                                        }
                                    }}
                                >
                                    {page.name}
                                </Button>

                            ))}
                        </Box>

                        <Box sx={{ flexGrow: 0 }}>

                            <Box sx={{
                                display: { xs: 'none', md: 'flex' }
                            }}>
                                <Button
                                    href="/app/dashboard"
                                    onClick={handleCloseNavMenu}
                                    sx={{
                                        my: 1, mx: 1.5, fontWeight: 600, color: 'white', display: 'block',
                                        '&:hover': {
                                            color: '#de80a0',
                                        }
                                    }}

                                >
                                    Login
                                </Button>

                                <motion.div
                                    whileHover={{ scale: 1.10 }}
                                    whileTap={{ scale: 0.95 }}
                                >
                                    <Button href="/app/dashboard" type="primary" variant="outlined" sx={{
                                        border: '2px solid #E91E63',
                                        boxShadow: '0 0 10px 3px #E91E63',
                                        color: 'white',
                                        borderRadius: '14px',
                                        mt: '5px',
                                        padding: '5px 15px',
                                        fontWeight: 700,
                                        textTransform: 'none',
                                        '&:hover': {
                                            backgroundColor: '#E91E63',
                                            border: '2px solid #E91E63',
                                        },
                                    }}>Get Started
                                    </Button>
                                </motion.div>
                            </Box>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
        </div>
    );
}
